import {m, Input, Button, Control} from '../../n2/components/base.js'
import {EmbeddedForm} from '../../n2/components/form.js'
import FormModel from '../../n2/data/FormModel.js'

export class UserPage extends Control {
    constructor(vnode) {
        super(vnode, '.w-full.min-h-full.flex.flex-col.items-center.justify-center.my-auto')
        this.success = false
    }

    getUser() {
        return this.attrs.user
    }

    getDataSource() {
        const user = this.getUser()
        return user && user.getDataSource()
    }

    getUserEntity() {
        const user = this.getUser()
        return user && user.getEntity()
    }

    getUserId() {
        const entity = this.getUserEntity()
        return entity && entity.id
    }

    getNext() {
        return this.attrs.next
    }

    getSuccessTitle() {
        return this.attrs.successTitle || 'Die Änderung wurde erfolgreich durchgeführt.'
    }

    getSuccessBody() {
        return this.attrs.successBody
    }

    getSuccessButton() {
        return this.attrs.successButton
    }

    getSuccessButtonLink() {
        return this.attrs.successButtonLink
    }

    getSuccessSeconds() {
        return 1
    }

    next() {
        this.success = true
        const next = this.getNext()
        next && setTimeout(() => (typeof next === 'function') ? next() : m.route.set(next), this.getSuccessSeconds() * 1000)
    }

    renderContent() {

    }

    renderChildren() {
        return m('.w-full.flex.flex-col.items-center.justify-center.flex-grow.my-auto',
            m('.relative.flex-col.flex.w-full.max-w-md.p-8.bg-white.bg-opacity-90.backdrop-blur-xl.rounded-2xl.shadow-xl.border.border-slate-200.border-opacity-80.my-auto', [
                this.success ?
                    [
                        m('p.text-brand1.text-center.font-bold.text-lg.mb-2', this.getSuccessTitle()),
                        this.getSuccessBody() && m('p.text-slate-600.text-center.text-sm.mb-4', this.getSuccessBody()),
                        this.getSuccessButton() && m('.text-center.my-4', m('a.inline-block.rounded-xl.font-semibold.focus:outline-none.bg-brand1.hover:bg-brand1-dark.text-white.py-2.px-5.shadow-sm.transition-all.duration-200', {href: this.getSuccessButtonLink(), title: this.getSuccessButton()}, this.getSuccessButton()))
                    ]
                    :
                    this.renderContent()
            ])
        )
    }
}

export class LoginPage extends UserPage {
    constructor(vnode) {
        super(vnode)
        this.email = undefined
        this.password = undefined
    }

    getSuccessTitle() {
        return this.getUser().isLoggedIn() ? 'Willkommen zurück!' : 'Sie haben sich erfolgreich abgemeldet.'
    }

    async login() {
        const user = this.getUser()
        await user.login(this.email, this.password)
        if (user.isLoggedIn()) this.next()
    }

    onKeyUp(ev) {
        if (ev.code === 'Enter') this.login()
    }

    async logout() {
        const user = this.getUser()
        await user.logout()
        if (!user.isLoggedIn()) this.next()
    }

    canSend() {
        return (
            this.email && this.email.length >= 8 &&
            this.password && this.password.length >= 8
        )
    }

    renderForms() {
        const user = this.getUser()
        if (user.isLoggedIn()) {
            return m(Button, {
                key: 'logout',
                class: 'mt-4 w-full py-2.5 rounded-xl shadow-sm font-semibold',
                disabled: !this.getUser().isLoggedIn(),
                onclick: () => this.logout()
            }, [
                'Abmelden'
            ])
        } else return m('.space-y-4', [
            m('div', { key: 'email-field' }, [
                m('label.block.text-xs.font-semibold.text-slate-600.uppercase.tracking-wider.mb-1.5', 'E-Mail'),
                m(Input, {
                    class: 'w-full block py-2.5 px-3.5 rounded-xl border-slate-300 focus:border-brand1 focus:ring-2 focus:ring-brand1 focus:ring-opacity-20 text-slate-800 text-sm transition-all',
                    type: 'email',
                    placeholder: 'name@beispiel.de',
                    required: true,
                    autofocus: true,
                    onChange: (v) => this.email = v,
                    onkeyup: (ev) => this.onKeyUp(ev),
                })
            ]),
            m('div', { key: 'password-field' }, [
                m('label.block.text-xs.font-semibold.text-slate-600.uppercase.tracking-wider.mb-1.5', 'Passwort'),
                m(Input, {
                    type: 'password',
                    class: 'w-full block py-2.5 px-3.5 rounded-xl border-slate-300 focus:border-brand1 focus:ring-2 focus:ring-brand1 focus:ring-opacity-20 text-slate-800 text-sm transition-all',
                    placeholder: '••••••••',
                    required: true,
                    onChange: (v) => this.password = v,
                    onkeyup: (ev) => this.onKeyUp(ev)
                })
            ]),
            m(Button, {
                key: 'login',
                class: 'mt-6 w-full py-3 rounded-xl font-bold text-white shadow-md hover:shadow-lg transition-all duration-200',
                disabled: !this.canSend(),
                onclick: () => this.login()
            }, [
                'Anmelden'
            ])
        ])
    }

    renderNote() {
        return this.attrs.renderLoginNote && this.attrs.renderLoginNote()
    }

    renderContent() {
        const lastMessage = this.getUser().getLastMessage()
        const lastCode = this.getUser().getLastCode()
        const user = this.getUser()
        return [
            m('.text-center.mb-6', [
                m('h2.text-2xl.font-bold.text-slate-800', 'Anmeldung'),
                m('p.text-sm.text-slate-500.mt-1', 'Geben Sie Ihre Zugangsdaten ein, um fortzufahren.')
            ]),
            !user.isLoggedIn() && this.renderNote(),
            lastMessage && lastCode !== 404 && m('div.p-3.mb-4.rounded-xl.bg-red-50.border.border-red-200.text-center.text-danger.text-sm.font-medium', lastMessage),
            this.renderForms(),
        ]
    }
}
